"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var CarouselRequest;
(function (CarouselRequest) {
    var Order = (function (_super) {
        __extends(Order, _super);
        function Order() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.role = undefined;
            _this.order = undefined;
            return _this;
        }
        return Order;
    }(BaseModel_1["default"]));
    CarouselRequest.Order = Order;
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.roles = undefined;
            _this.active = undefined;
            _this.bookIds = undefined;
            _this.order = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    CarouselRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.roles = undefined;
            _this.active = undefined;
            _this.bookIds = undefined;
            _this.order = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    CarouselRequest.Update = Update;
})(CarouselRequest = exports.CarouselRequest || (exports.CarouselRequest = {}));
var CarouselResponse;
(function (CarouselResponse) {
    var Carousel = (function (_super) {
        __extends(Carousel, _super);
        function Carousel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.roles = undefined;
            _this.active = undefined;
            _this.books = undefined;
            return _this;
        }
        return Carousel;
    }(BaseModel_1["default"]));
    CarouselResponse.Carousel = Carousel;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length || 0;
            _this.offset = offset || 0;
            _this.pagination = pagination || 100;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    CarouselResponse.All = All;
})(CarouselResponse = exports.CarouselResponse || (exports.CarouselResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/carousel.js
// module id = ../model/dist/models/carousel.js
// module chunks = main